import { FC } from "react";
import { IIncomingRoom, ICustomerData } from "../../../app/chat/types";
import getInitials from "../../../utils/getInitials";
import CallXtraSmallIcon from "@ht/shared/fonts/deos-pis/call-outline-extra-small";
import MailXtraSmallIcon from "@ht/shared/fonts/deos-pis/mail-outline-extra-small";
import ShieldXtraSmallIcon from "@ht/shared/fonts/deos-pis/shield-outline-extra-small";
import ChannelXtraSmallIcon from "@ht/shared/fonts/deos-pis/channel-outline-extra-small";
import PlusIcon from "@ht/shared/fonts/deos-pis/plus";
import SearchIcon from "@ht/shared/fonts/deos-pis/search";
import PencilIcon from "@ht/shared/fonts/deos-pis/pencil";
import MaleIcon from "@ht/shared/fonts/deos-pis/male";
import FemaleIcon from "@ht/shared/fonts/deos-pis/female";
import CalendarIcon from "@ht/shared/fonts/deos-pis/calendar-outline-extra-small";
import ReligionIcon from "@ht/shared/fonts/deos-pis/pray";
import PointIcon from "@ht/shared/fonts/deos-pis/pin";
import moment from "moment";
import { Textarea } from "@ht/components";
import ChannelIcon from "../../../components/chat/ChannelIcon";
import generateUuid from "../../../utils/generateUuid";

interface IProps {
    opponent: IIncomingRoom;
    customerData: ICustomerData;
    onUpdatedCustomer(roomId: string): void;
}

const ProfileBody: FC<IProps> = ({ opponent, customerData }) => {
    const getServiceGroupName = () => {
        let result: string = opponent.serviceGroupName;
        if (opponent.serviceGroupName == undefined) result = "-";
        return result;
    };
    const getChannelName = () => {
        let result: string = opponent.channelName;
        if (opponent.channelName == undefined) result = "-";
        return result;
    };
    const age = customerData?.dob
        ? moment().diff(moment(customerData?.dob), "years")
        : -1;
    return (
        <>
            <div className="flex flex-col justify-between h-[calc(100vh-125px)]">
                <div className="px-5 overflow-y-scroll h-[calc(100vh-150px)]">
                    <div className="flex pt-4 flex-col items-center justify-center">
                        <div className="rounded-full bg-gray-300 w-[72px] h-[72px] flex items-center justify-center text-lg">
                            {customerData?.profile_picture &&
                            customerData?.profile_picture !== "" ? (
                                <img
                                    src={customerData?.profile_picture}
                                    alt=""
                                    className="rounded-full w-[72px] h-[72px]"
                                />
                            ) : (
                                <span>
                                    {getInitials(customerData.fullname ?? "")}
                                </span>
                            )}
                        </div>
                        <div className="text-[16px] mt-3 font-semibold text-gray-700 whitespace-pre-wrap text-center">
                            {" "}
                            {customerData?.fullname ?? opponent.fullName}
                        </div>
                    </div>
                    <div className="flex flex-row justify-center items-center gap-[8px] pt-[2px]">
                        {age > 0 && (
                            <div className="bg-primary-50 text-primary font-semibold p-1 rounded-md">
                                {age} Years Old
                            </div>
                        )}
                        {customerData?.gender && (
                            <div className="bg-primary-50 text-primary font-semibold p-1 rounded-md flex flex-row gap-[4px] items-center justify-center">
                                {customerData?.gender.toLowerCase() ===
                                    "male" && (
                                    <MaleIcon className="w-[14px] h-[14px] text-primary"></MaleIcon>
                                )}
                                {customerData?.gender.toLowerCase() ===
                                    "female" && (
                                    <FemaleIcon className="w-[14px] h-[14px] text-primary"></FemaleIcon>
                                )}
                                {customerData?.gender}
                            </div>
                        )}
                    </div>
                    <div className="py-4">
                        {customerData?.email && customerData.email.length > 0 && (
                            <div className="mb-5 flex flex-col">
                                <div className="flex flex-row">
                                    <MailXtraSmallIcon className="text-gray-400 mr-1" />
                                    <div className="text-base font-medium text-gray-400 mb-1">
                                        Email address
                                    </div>
                                </div>
                                {customerData.email.map((emailItem) => {
                                    const emailstring = (
                                        emailItem ?? ""
                                    ).replace(
                                        /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                                        (_, a: string, b: string, c: string) =>
                                            a + b.replace(/./g, "*") + c
                                    );
                                    return (
                                        <div
                                            key={`email${generateUuid()}`}
                                            className="text-md font-medium text-gray-700 truncate"
                                        >
                                            {emailstring}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                        {customerData?.phone_number &&
                            customerData.phone_number.length > 0 && (
                                <div className="mb-5 flex flex-col">
                                    <div className="flex flex-row">
                                        <CallXtraSmallIcon className="text-gray-400 mr-1" />
                                        <div className="text-base font-medium text-gray-400 mb-1">
                                            Phone number
                                        </div>
                                    </div>
                                    {customerData.phone_number.map(
                                        (phoneItem) => {
                                            const phonestring = (
                                                phoneItem ?? ""
                                            ).replace(/(?<=....).(?=..)/g, "*");
                                            return (
                                                <div
                                                    key={`phone${generateUuid()}`}
                                                    className="text-md font-medium text-gray-700 truncate"
                                                >
                                                    {phonestring}
                                                </div>
                                            );
                                        }
                                    )}
                                </div>
                            )}
                        {customerData?.facebook_ids &&
                            customerData.facebook_ids.length > 0 && (
                                <div className="mb-5 flex flex-col">
                                    <div className="flex flex-row">
                                        <ChannelIcon
                                            className="text-gray-400 mr-1"
                                            channel={""}
                                        />
                                        <div className="text-base font-medium text-gray-400 mb-1">
                                            Facebook
                                        </div>
                                    </div>
                                    {customerData.facebook_ids.map((fbItem) => {
                                        const fbString = (fbItem ?? "").replace(
                                            /(?<=....).(?=..)/g,
                                            "*"
                                        );
                                        return (
                                            <div
                                                key={`facebook_ids${generateUuid()}`}
                                                className="text-md font-medium text-gray-700 truncate"
                                            >
                                                {fbString}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        {customerData?.dob != undefined && (
                            <div className="mb-5 flex flex-col">
                                <div className="flex flex-row">
                                    <CalendarIcon className="text-gray-400 mr-1" />
                                    <div className="text-base font-medium text-gray-400 mb-1">
                                        Date of Birth
                                    </div>
                                </div>
                                <div className="text-md font-medium text-gray-700 truncate">
                                    {customerData?.dob
                                        ? moment(customerData?.dob).format(
                                              "DD MMMM yyy"
                                          )
                                        : ""}
                                </div>
                            </div>
                        )}
                        {customerData?.religion && (
                            <div className="mb-5 flex flex-col">
                                <div className="flex flex-row">
                                    <ReligionIcon className="text-gray-400 mr-1 w-[16px] h-[16px]" />
                                    <div className="text-base font-medium text-gray-400 mb-1">
                                        Religion
                                    </div>
                                </div>
                                <div className="text-md font-medium text-gray-700 truncate">
                                    {customerData?.religion}
                                </div>
                            </div>
                        )}
                        {customerData?.address && (
                            <div className="mb-5 flex flex-col">
                                <div className="flex flex-row">
                                    <PointIcon className="text-gray-400 mr-1 w-[16px] h-[16px]" />
                                    <div className="text-base font-medium text-gray-400 mb-1">
                                        Address
                                    </div>
                                </div>
                                <div className="text-md font-medium text-gray-700 wrap">
                                    <Textarea
                                        id="addr"
                                        name="addr"
                                        onChange={() => {}}
                                        className="max-h-[200px] min-h-[80px] text-md text-black font-semibold -ml-[10px] bg-transparent focus:bg-transparent border-0"
                                        value={customerData?.address}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="border-t border-t-gray-200 mb-5"></div>
                        <div className="mb-5 flex flex-col">
                            <div className="flex flex-row">
                                <ShieldXtraSmallIcon className="text-gray-400 mr-1" />
                                <div className="text-base font-medium text-gray-400 mb-1">
                                    Service Group
                                </div>
                            </div>
                            <div className="text-md font-medium text-gray-700 truncate">
                                {getServiceGroupName()}
                            </div>
                        </div>
                        <div className="mb-5 flex flex-col">
                            <div className="flex flex-row">
                                <ChannelXtraSmallIcon className="text-gray-400 mr-1" />
                                <div className="text-base font-medium text-gray-400 mb-1">
                                    Channel
                                </div>
                            </div>
                            <div className="text-md font-medium text-gray-700 truncate">
                                {getChannelName()}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="px-5 mt-[8px] flex flex-col gap-[8px]">
                    {customerData?.tenant_id ? (
                        <button className="bg-white border border-gray-200 p-2 rounded-lg flex flex-row justify-center items-center gap-[8px]">
                            <PencilIcon className="w-[16px] h-16px text-black" />
                            <span className="text-base font-semibold text-black">
                                {" "}
                                Edit Contact
                            </span>
                        </button>
                    ) : (
                        <>
                            <button className="bg-white border border-gray-200 p-2 rounded-lg flex flex-row justify-center items-center gap-[8px]">
                                <PlusIcon className="w-[16px] h-16px text-black" />
                                <span className="text-base font-semibold text-black">
                                    {" "}
                                    Add Contact
                                </span>
                            </button>
                            <button className="bg-white border border-gray-200 p-2 rounded-lg flex flex-row justify-center items-center gap-[8px]">
                                <SearchIcon className="w-[16px] h-16px text-black" />
                                <span className="text-base font-semibold text-black">
                                    {" "}
                                    Add to Existing Contact
                                </span>
                            </button>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default ProfileBody;
